<template>
<div id="recuperaciones_ws">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col sm="12">
        <base-material-card color="primary" icon="library_books" title="Recuperaciones de Documentos Importador Exportador" class="elevation-1 px-5 py-3">

          <v-card-actions style="margin-top:-50px">
            <v-spacer></v-spacer>
            <v-btn small fab dark color="blue" @click="modal_acuses= !modal_acuses" :loading="loading" title="Coves desde Acuse" v-tippy>
              <v-icon>list</v-icon>
            </v-btn>
            <v-btn small fab dark color="red" @click="modal_recuperacion= !modal_recuperacion" :loading="loading" title="Reintentar Recuperaciones" v-tippy>
              <v-icon>reply_all</v-icon>
            </v-btn>
          </v-card-actions>
          <br>
          <v-tabs grow style="margin-bottom: 30px;">
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab :key="'in-view'">Vista Previa</v-tab>
            <v-tab :key="'in-report'">Generar en Reporte</v-tab>

            <v-tab-item :key="'in-view'">
              <v-card-text>
                <v-card-title>
                  <span class="headline"></span>
                </v-card-title>
                <v-form ref="form1" lazy-validation>
                  <v-container grid-list-md text-xs-center>
                    <v-row row wrap>
                      <v-col sm="9">
                        <v-autocomplete v-model="model.tipo_reporte" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Reporte" @change="clear_values()" :rules="[rules.required]">
                        </v-autocomplete>
                      </v-col>
                      <v-col sm="3" md="3" lg="3" >
                        <v-text-field v-model="model.rfc_grupo" label="RFC" prepend-icon="fa-search" maxlength="20"></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row v-if="model.tipo_reporte == 1" row wrap>
                      <v-col cols="10">
                        <v-text-field v-model="model.pedimento" label="Pedimento" prepend-icon="fa-search" :rules="[rules.required, validaPedimento]"></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-btn icon title="Pegar Listado" @click="listado=''; dialog1 = !dialog1" v-tippy>
                          <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row v-if="model.tipo_reporte == 4" row wrap>
                      <v-col sm="12">
                        Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                      </v-col>
                      <v-col sm="10">
                        <v-combobox v-model="lista_filtrada" label="Lista de archivos" multiple persistent-hint small-chips disabled color="green">
                        </v-combobox>
                      </v-col>
                      <v-col cols="2">
                        <v-btn icon title="Pegar Listado" @click="dialogListado = !dialogListado" v-tippy>
                          <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row v-if="model.tipo_reporte == 3 || model.tipo_reporte == 2" row wrap>
                      <v-col>

                        <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                              :rules="[rules.required, validaDias, validaFecha]">
                            </v-text-field>
                          </template>

                          <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu3 = false">
                            <v-spacer />

                            <v-btn color="secondary" x-small @click="menu3 = false">
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col>
                        <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                              :rules="[rules.required, validaDias, validaFecha]">
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu4 = false">
                            <v-spacer />

                            <v-btn color="secondary" x-small @click="menu4 = false">
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>

                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>

                <v-btn v-if="to_download.length > 0" rounded color="info" @click="download_files" :loading="loading">
                  <v-icon>done</v-icon>Descargar Seleccionados
                </v-btn>
                <v-btn v-if="datanorecuperados.length > 0 && superusuario" rounded color="red" @click="reenviar_no_recuperados" :loading="loading">
                  <v-icon>done</v-icon>Enviar Recuperar
                </v-btn>
                <v-spacer></v-spacer>

                <v-btn rounded color="success" @click="get_data_view(0)" :loading="loading">
                  <v-icon>done</v-icon>Vista Previa
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <v-client-table ref="vuetable" :data="data_view.datos" :columns="data_view.columns" :options="data_view.options" class="elevation-2 pa-2 scroll-table">
                  <template slot="noResults">
                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                  </template>

                  <div slot="filter__id_pedimento">
                    <input type="checkbox" class="form-control check-all" v-model='allChecked' @change="check_all()">
                  </div>
                  <template slot="id_pedimento" slot-scope="props" v-if="props.row.estatus=='RECUPERADO'">
                    <div style="display:flex; justify-content:center;">
                      <input :id="props.row.id_pedimento +'-'+props.row.key" type="checkbox" v-model="to_download" :value="props.row.key" />
                    </div>
                  </template>

                  <template slot="actions_view" slot-scope="props">
                    <v-speed-dial direction="left" open-on-hover :style="'text-align:center;'">
                      <template v-slot:activator>
                        <v-btn x-small fab dark color="primary">
                          <v-icon>reorder</v-icon>
                        </v-btn>
                      </template>
                      <v-btn x-small fab dark color="orange" @click="mostrarErroresRecuperacion(props.row)" title="Errores de Recuperación" v-tippy>
                        <v-icon>report</v-icon>
                      </v-btn>
                      <v-btn x-small fab dark color="red" v-if="props.row.simular===true && props.row.tipo_validacion==4" @click="simularEstado(props.row.id_pedimento)" title="Simular estado 730" v-tippy>
                        <v-icon>mdi-call-split</v-icon>
                      </v-btn>
                      <v-btn x-small fab dark color="green" v-if="props.row.estatus=='RECUPERADO' && props.row.ext=='xml'" @click="downloadFile(props.row.key)" title="Descarga XML" v-tippy>
                        <v-icon>code</v-icon>
                      </v-btn>
                      <v-btn x-small fab dark color="red" v-if="props.row.estatus=='RECUPERADO' && props.row.ext=='pdf'" @click="downloadFile(props.row.key)" title="Descarga PDF" v-tippy>
                        <v-icon>picture_as_pdf</v-icon>
                      </v-btn>
                      <v-btn x-small fab dark color="info"
                        v-if="getPermisoReenvio(props.row) && props.row.estatus!='PENDIENTE' && props.row.estatus!='EN COLA' && props.row.estatus!='PENDIENTE AA' &&  props.row.tipo != 'XML ESTADO DS' &&  props.row.tipo != 'PDF ESTADO DS'"
                        @click="reenviarArchivo(props.row)" :title="props.row.ext=='xml'?'Volver a Recuperar':'Regenerar'" v-tippy>
                        <v-icon>send</v-icon>
                      </v-btn>

                    </v-speed-dial>
                  </template>
                </v-client-table>
              </v-card-text>
            </v-tab-item>
            <v-tab-item :key="'in-report'">
              <v-card-text>
                <v-card-title>
                  <span class="headline"></span>
                </v-card-title>
                <v-form ref="formReporte">
                  <v-container grid-list-md text-xs-center>
                    <v-row row wrap>
                      <v-col sm="7">
                        <v-autocomplete v-model="model.tipo_reporte" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Reporte" @change="clear_values()" :rules="[rules.required]">
                        </v-autocomplete>
                      </v-col>
                      <v-col sm="3" md="3" lg="3" >
                        <v-text-field v-model="model.rfc_grupo" label="RFC" prepend-icon="fa-search" maxlength="20"></v-text-field>
                      </v-col>
                      <v-col sm="2">
                        <v-switch v-model="norecuperados" color="red darken-3" label="Solo no recuperados"></v-switch>
                      </v-col>

                    </v-row>

                    <v-row v-if="model.tipo_reporte == 1" row wrap>
                      <v-row>
                        <v-col cols="10">
                          <v-text-field v-model="model.pedimento" label="Pedimento" prepend-icon="fa-search" :rules="[rules.required, validaPedimento]"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                          <v-btn icon title="Pegar Listado" @click="listado=''; dialog2 = !dialog2" v-tippy>
                            <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-row>

                    <v-row v-if="model.tipo_reporte == 4" row wrap>
                      <v-col sm="12">
                        Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                      </v-col>
                      <v-col sm="10">
                        <v-combobox v-model="lista_filtrada" label="Lista de archivos" multiple persistent-hint small-chips disabled color="green">
                        </v-combobox>
                      </v-col>
                      <v-col cols="2">
                        <v-btn icon title="Pegar Listado" @click="dialogListado = !dialogListado" v-tippy>
                          <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row v-if="model.tipo_reporte == 3 || model.tipo_reporte == 2" row wrap>
                      <v-col>
                        <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                              :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]">
                            </v-text-field>
                          </template>

                          <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                            <v-spacer />

                            <v-btn color="secondary" x-small @click="menu1 = false">
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col>
                        <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                          <template v-slot:activator="{ on }">
                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                              :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]">
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                            <v-spacer />

                            <v-btn color="secondary" x-small @click="menu2 = false">
                              Cancelar
                            </v-btn>
                          </v-date-picker>
                        </v-menu>

                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn rounded color="success" @click="generar_reporte_sqs(0)" :loading="loading">
                  <v-icon>done</v-icon>Generar Reporte
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <v-refresh-button :funcion="cargar" />

                <v-client-table ref="vuetable2" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2">
                  <template slot="noResults">
                    <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                  </template>

                  <template slot="actions" slot-scope="props">
                    <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)">
                      <v-icon dark>get_app</v-icon>
                    </v-btn>
                    <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)">
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                  </template>
                </v-client-table>
              </v-card-text>
            </v-tab-item>

          </v-tabs>


        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
  <v-dialog v-model="dialog1" max-width="500px">
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de pedimentos</h5>
        <span>Uno por línea</span>
        <v-form ref="formListado" lazy-validation="">
          <v-textarea outlined rows="15" v-model="listado" :rules="[validaListadoPreview]"></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="listado=''; dialog1 = false">Cancelar</v-btn>
        <v-btn small color="primary" @click="generaReporteListado('preview');">Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialog2" max-width="500px">
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de pedimentos</h5>
        <span>Uno por línea</span>
        <v-form ref="formListado" lazy-validation="">
          <v-textarea outlined rows="15" v-model="listado" :rules="[validaListado]"></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="listado=''; dialog2 = false">Cancelar</v-btn>
        <v-btn small color="primary" @click="generaReporteListado('completo');">Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- <v-dialog v-model="modal_recuperacion" max-width="500px">
    <v-card>
      <v-card-text>
        <h5><b>Reintentar Recuperaciones</b></h5>
        <span>Todos los archivos con estatus de error y no recuperables se enviarán a recuperar nuevamente. Este proceso podría tardar días dependiendo del total de sus archivos.</span>
        <v-form ref="formRecuperacion" lazy-validation="" style="margin-top: 10px;">
          <v-container grid-list-md text-xs-center>
            <v-row row wrap>
              <v-col>

                <v-menu ref="menu5" v-model="menu5" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-on="on" v-model="model_recuperacion.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model_recuperacion.fecha_de = parseDate(model_recuperacion.fecha_de)" v-mask="'####-##-##'"
                      :rules="[rules.required, validaFecha]">
                    </v-text-field>
                  </template>

                  <v-date-picker v-model="model_recuperacion.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu5 = false">
                    <v-spacer />

                    <v-btn color="secondary" large @click="menu5 = false">
                      Cancelar
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-menu ref="menu6" v-model="menu6" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-on="on" v-model="model_recuperacion.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model_recuperacion.fecha_a= parseDate(model_recuperacion.fecha_a)" v-mask="'####-##-##'"
                      :rules="[rules.required, validaFecha]"></v-text-field>
                  </template>
                  <v-date-picker v-model="model_recuperacion.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu6 = false">
                    <v-spacer />

                    <v-btn color="secondary" large @click="menu6 = false">
                      Cancelar
                    </v-btn>
                  </v-date-picker>
                </v-menu>

              </v-col>
            </v-row>
            <v-row row wrap>
              <v-row>
                <v-col>
                  <v-combobox v-model="model_recuperacion.archivos" :items="tipo_archivos" label="Tipos de Archivos" multiple chips :rules="[rules.required]"></v-combobox>
                </v-col>
              </v-row>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="modal_recuperacion = false">Cancelar</v-btn>
        <v-btn small color="primary" @click="genera_recuperacion">Enviar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog> -->
  <v-dialog v-model="modalErroresRecuperacion" min-width="50%" max-width="70%">
    <v-card>
      <v-card-title>
        <v-card class="primary white--text titulomodal">
          <v-icon @click.native="modalErroresRecuperacion = false" class="white--text">cancel</v-icon>&nbsp;
          <span class="subheading">
            <strong>Errores de Recuperación Webservice</strong>
          </span>
        </v-card>
      </v-card-title>
      <v-card-text>
        <h5>Intentos de Recuperación: {{intentosRecuperacion}} </h5>
        <span>{{ mensajeErrores }}</span>

        <v-client-table ref="vuetableErroresRecuperacion" :data="errores" :columns="errores_columns" :options="errores_options" class="elevation-2 pa-2 scroll-table">
          <template slot="noResults">
            <v-alert :value="true" icon="info" color="info">No se encontró ningun registro</v-alert>
          </template>
        </v-client-table>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="modalErroresRecuperacion = false">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogListado" max-width="500px">
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de documentos</h5>
        <span>Uno por línea</span>
        <v-form ref="formListado" lazy-validation="">
          <v-textarea outlined rows="15" v-model="model.archivo" :rules="[rules.required, maxListaRule]"></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="model.archivo='';dialogListado = false">Cancelar</v-btn>
        <v-btn small color="primary" @click="setListValues();">Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
  components: {
    "v-refresh-button": RefreshButton,
  },
  created: function() {
    this.URL = this.$hostname + "reportes/";
    this.loading = false;
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.model.rfc = this.$local_storage.get("rfc_grupo");
    this.model.id_grupo = this.$local_storage.get("id_grupo");
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario")
      this.permisoEliminar = true;
    this.cargarErrores();
  },
  data: () => ({

    to_download: [],
    emisores: [],
    norecuperados: true,
    emisor_seleccionado: "",
    allChecked: false,
    permisoEliminar: false,
    tab: null,
    lista_filtrada: [],
    lista_filtrada_acuses: [],
    errores_ws: [],
    errores: [],
    errores_columns: ["fecha", "error"],
    errores_options: {
      filterable: ["fecha", "error"],
      sortable: ["fecha", "error"],
    },
    modalErroresRecuperacion: false,
    intentosRecuperacion: 0,
    mensajeErrores: '',
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Recuperaciones de Documentos Importador Exportador",
        disabled: true,
        to: ""
      }
    ],
    tipos: [{
        "id": 1,
        "text": "Por Pedimento | Listado de Pedimentos"
      },
      {
        "id": 3,
        "text": "Por Fechas de Pedimento"
      }, {
        "id": 4,
        "text": "Por Lista de Documentos (Pedimento | Cove | eDocument)"
      }
    ],
    tipo_archivos: [{
      'id': 1,
      'text': 'Pedimentos'
    }, {
      'id': 4,
      'text': 'Estado de Pedimentos'
    }, {
      'id': 6,
      'text': 'Partidas'
    }, {
      'id': 7,
      'text': 'Coves'
    }, {
      'id': 10,
      'text': 'Acuses de Cove'
    }, {
      'id': 11,
      'text': 'eDocuments'
    }, {
      'id': 14,
      'text': 'Acuses de eDocuments'
    }, {
      'id': 15,
      'text': 'Remesas'
    }, {
      'id': 18,
      'text': 'Acuse de Remesas'
    }],
    dialog1: false,
    dialog2: false,
    modal_recuperacion: false,
    modal_acuses: false,
    modal_emisores: false,
    dialogListado: false,
    listado: "",
    datos: [],
    columns: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    loading: true,
    show_loading: true,
    acuses: [],
    model: {
      rfc: "",
      usuario: "",
      pedimento: "",
      fecha_de: "",
      fecha_a: "",
      reporte_url: "/reportes_vucem/recuperaciones_aa/",
      nombre_reporte: "Recuperaciones AA",
      tipo: "Recuperaciones AA",
      tipo_reporte: "",
      norecuperados: 0,
      archivo: "",
      rfc_grupo:"",
      id_grupo:""

    },
    model_recuperacion: {
      rfc: '',
      fecha_de: '',
      fecha_a: '',
      archivos: '',
      usuario: '',
      origen:"Recuperaciones AA"
    },
    model_acuses: {
      id_documento: "",
      edocument: "",
      emisor: "",
    },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    data_view: {
      datos: [],
      columns: ['id_pedimento', 'rfc', 'no_pedimento', 'clave_documento', 'tipo_operacion', 'tipo_pedimento', 'fecha_pedimento',
        'tipo', 'archivo', 'estatus', 'error', 'fecha_actualizacion', 'actions_view'
      ],
      options: {
        filterable: ['rfc', 'no_pedimento', 'clave_documento', 'tipo_operacion', 'tipo_pedimento', 'fecha_pedimento',
          'tipo', 'archivo', 'estatus', 'error', 'fecha_actualizacion'
        ],
        sortable: ['rfc', 'no_pedimento', 'clave_documento', 'tipo_operacion', 'tipo_pedimento', 'fecha_pedimento',
          'tipo', 'archivo', 'estatus', 'error', 'fecha_actualizacion'
        ],
        headings: {
          rfc: 'RFC',
          id_pedimento: '',
          no_pedimento: 'No. Pedimento',
          'clave_documento': "Clave Documento",
          'tipo_operacion': "Tipo Operación",
          'tipo_pedimento': "Tipo Pedimento",
          fecha_pedimento: 'Fecha Pedimento',
          tipo: 'Tipo',
          archivo: 'Archivo',
          estatus: 'Estatus',
          error: 'Error',
          fecha_actualizacion: 'Fecha Actualización',
          actions_view: 'Documentos'
        }
      }
    }
  }),
  computed: {
    datanorecuperados() {
      let result = [];
      if (this.$refs.vuetable != null) {
        result = this.$refs.vuetable.allFilteredData.filter(r => r.estatus != 'PENDIENTE' && r.estatus != 'EN COLA' && r.estatus != 'PENDIENTE AA');
        return result;
      } else {
        result = this.data_view.datos.filter(r => r.estatus != 'PENDIENTE' && r.estatus != 'EN COLA' && r.estatus != 'PENDIENTE AA');
        return result;
      }

    },
    superusuario() {
      return this.$local_storage.get("tipo_usuario") == "Super Usuario";
    },

  },
  methods: {
    getPermisoReenvio: function(row) {
      //Usuarios tipo Cliente y Grupo solo pueden reenviar Partidas, Coves, EDocuments y Remesas
      //Super Usuario y Soporte, pueden reenviar cualquiera
      const tipos = ["XML PARTIDA", "XML COVE", "PDF COVE", "PDF ACUSE COVE", "XML EDOCUMENT",
        "PDF EDOCUMENT", "PDF ACUSE EDOCUMENT", "XML REMESA", "PDF REMESA", "PDF ACUSE REMESA"
      ];
      const clientes = tipos.find(e => e == row.tipo);
      var tipo_usuario = this.$local_storage.get("tipo_usuario");

      if (row.estatus != "PENDIENTE" && row.estatus != "EN COLA" && row.estatus != 'PENDIENTE AA') {
        if (clientes != undefined && (tipo_usuario == "Cliente" || tipo_usuario == "Grupo")) {
          return true;
        } else if (tipo_usuario == "Super Usuario" || tipo_usuario == "Soporte") {
          return true;
        }
      }
      if (row.tipo == "XML PEDIMENTO" && this.$local_storage.get('eDrive.recuperaciones.reenviar') == 100 && row.estatus != "PENDIENTE" && row.estatus != "EN COLA" && row.estatus != 'PENDIENTE AA') {
        return true;
      }
      return false;
    },
    maxListaRule: function() {
      if (this.model.archivo == '' || this.model.archivo == undefined || Array.isArray(this.model.archivo)) {
        return "Lista vacia";
      }

      let x = this.model.archivo.split("\n");

      if (x.length > 250) {
        return "No se puede consultar mas de 250 pedimentos";
      }

      return true;
    },
    maxListaRuleAcuses: function() {
      if (this.acuses == '' || this.acuses == undefined || Array.isArray(this.acuses)) {
        return "Lista vacia";
      }

      let x = this.acuses.split("\n");

      if (x.length > 50) {
        return "No se puede consultar mas de 50 pedimentos";
      }

      return true;
    },
    setListValues: function() {
      this.lista_filtrada = [];
      let to_list = this.get_array_lista(this.model.archivo);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada.push(to_list[i]);
        }
      }
      this.dialogListado = !this.dialogListado;
    },
    get_array_lista: function(cadena) {
      let data = cadena.split("\n");
      let newarr = data.filter(a => a.trim() !== '');
      for (var i = 0; i < newarr.length; i++) {
        newarr[i] = newarr[i].trim();
        newarr[i] = newarr[i].replace(',', '');
        newarr[i] = newarr[i].replace('.', '');
      }

      return newarr;
    },
    validaArchivo: function() {
      if (this.model.archivo != "" && !Array.isArray(this.model.archivo)) {
        this.model.archivo = this.model.archivo.trim();
        if (this.model.archivo.toString().length < 4) {
          return "Nombre Documento no debe tener menos de 4 caracteres";
        }
      }
      return true;
    },
    validaPedimento: function() {
      if (this.model.pedimento != "") {
        if (!this.validarPatronPedimento(this.model.pedimento))
          return "Pedimento no válido. Ejemplo: 240-0123-0000123";
      }
      return true;
    },
    validarPatronPedimento(pedimento) {
      const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
      return patternPedimento.test(pedimento);
    },
    validaListado: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 pedimento. Favor de verificar.";
      } else if (listadoSinEspacios.length > 250) {
        return "No se puede consultar mas de 250 pedimentos";
      } else {
        for (var k in listadoSinEspacios) {
          if (!this.validarPatronPedimento(listadoSinEspacios[k]))
            return "Verificar pedimentos no válidos. Ejemplo: 240-0123-0000123";
        }
      }

      return true;
    },
    validaListadoPreview: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 pedimento. Favor de verificar.";
      } else if (listadoSinEspacios.length > 250) {
        return "No se puede consultar mas de 250 pedimentos en Vista Previa";
      } else {
        for (var k in listadoSinEspacios) {
          if (!this.validarPatronPedimento(listadoSinEspacios[k]))
            return "Verificar pedimentos no válidos. Ejemplo: 240-0123-0000123";
        }
      }

      return true;
    },
    removerLineasVacias(listado) {
      var listadoSplit = this.listado.split("\n");
      var listadoSinEspacios = listadoSplit.filter(item => {
        return item.trim() != "";
      });
      return listadoSinEspacios;
    },
    reenviarArchivo(row) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "Esta acción volverá a encolar el documento para su recuperación/regeneración. ¿Desea continuar?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.reenviar(row);
        }
      });
    },
    reenviar: function(row) {
      let data = {
        "key": row.id_pedimento,
        "tipo": row.tipo_validacion,
        "filename": row.archivo,
        "estatus": 0, //Se deja en Pendiente para que lo vuelva a encolar
        "size": 0,
        "error": "",
        "usuario": this.$local_storage.get("id_usuario",""),        
        "origen": "Recuperaciones AA"
      };

      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios.post("https://apivucem.econnectpro.mx/vucem/actualizar_validacion/", data)
        .then(res => {
          //No hacemos nada aqui, ya que puede regresar timeout
        })
        .catch(err => {
          //Puede ser que regrese un timeout, pero igualmente se mostrará mensaje de exito
        }).then(() => {
          this.$root.$dialogLoader.hide();
          //Solo en caso de que se regenere el 12-PDF de eDocument, también se tiene que mandar el 11-XML del eDocument
          if (row.tipo_validacion == 12) {
            row.tipo_validacion = 11;
            this.reenviar(row);
          } else {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El archivo se volverá a encolar para su recuperación/regeneración.",
              footer: "",
              showCancelButton: false,
              //cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              //cancelButtonText: "Cancelar"
            }).then(result => {
              this.data_view.datos = [];
              this.get_data_view(0);
            });

          }

        });

    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    validaDias: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
        if (Math.abs(diferencia) > 31)
          return "Periodo máximo de consulta 31 dias. Favor de verificar."
      }
      return true;
    },
    cargar: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        tipo: this.model.tipo
      };
      axios.post(this.URL + "get_reportes/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos = res.data;
            this.datos.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud)
            });
            for (var k in this.datos) {
              this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
              this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
              this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
              this.datos[k].criterio = this.getCriterioPredeterminados(this.datos[k].criterio);
            }
          }
        })
        .catch(err => {

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores",
        "No Recuperable", "Token Incorrecto", "Reprogramado", , "Pendiente AA"
      ];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminados: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          if (params.tipo_reporte == 1) {
            if (params.lista != undefined && params.lista.length > 0) {
              return "Buscado por lista de pedimentos: " + params.lista.length;
            } else if (params.pedimento != undefined)
              return "Pedimento: " + params.pedimento;
            else
              return "Buscado por lista de pedimentos";
          } else if (params.tipo_reporte == 4) {
            return "Por lista de Documento";
          } else {
            return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
          }
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }

    },
    get_data_view: function(opcion = 0) {
      if (!this.$refs.form1.validate() && opcion == 0) { //Opción sirve para saltar la validación cuando se busca por listado
        //Alguna operación o mensaje
      } else {
        if (this.model.tipo_reporte == 4 && this.model.archivo == '') {
          this.$swal({
            type: "info",
            title: "Información",
            text: "Debes ingresar al menos un elemento a la lista",
            footer: ""
          });

          return false;
        }

        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;
        data["lista"] = this.removerLineasVacias(this.listado);
        if (data.pedimento == '') delete(data['pedimento']);
        if (data.fecha_de == '') delete(data['fecha_de']);
        if (data.fecha_a == '') delete(data['fecha_a']);
        if (data.archivo == '') delete(data['archivo']);
        if (data.tipo_reporte == 4) {
          data['lista'] = this.get_array_lista(data['archivo']);
          delete(data['archivo']);
        }

        axios({
            method: "post",
            url: this.$hostname + "reportes_vucem/recuperaciones_aa_preview/",
            data: data
          })
          .then(response => {
            this.to_download = [];
            this.data_view.datos = response.data;
            for (var k in this.data_view.datos) {
              this.data_view.datos[k].error = this.getErrorWS(this.data_view.datos[k].error);
            }
          })
          .catch(error => {
            let mensaje;
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
            } else {
              mensaje = "Reporte demasiado grande para vista previa. Intenta con un periodo más corto";
            }

            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.listado = "";
            this.model.archivo = '';
            this.lista_filtrada = [];
            this.model.lista = '';
            this.$root.$dialogLoader.hide();
          });
      }
    },
    generar_reporte_sqs(opcion = 0) {
      if (!this.$refs.formReporte.validate() && opcion == 0) { //Opción sirve para saltar la validación cuando se busca por listado
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;
        data["lista"] = this.removerLineasVacias(this.listado);
        if (data.pedimento == '') delete(data['pedimento']);
        if (data.fecha_de == '') delete(data['fecha_de']);
        if (data.fecha_a == '') delete(data['fecha_a']);
        if (data.archivo == '') delete(data['archivo']);
        if (data.tipo_reporte == 4) {
          data['lista'] = this.get_array_lista(data['archivo']);
          delete(data['archivo']);
        }
        if (this.norecuperados)
          data.norecuperados = 1;
        else
          data.norecuperados = 0;

        axios({
            method: "post",
            url: this.$hostname + "reportes/save_reporte/",
            data: data
          })
          .then(response => {
            this.to_download = [];
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.listado = "";
            this.model.archivo = '';
            this.lista_filtrada = [];
            this.model.lista = '';
            this.cargar();
            this.$root.$dialogLoader.hide();
          });
      }
    },
    genera_recuperacion: function() {
      if (!this.$refs.formRecuperacion.validate()) {
        return false;
      }
      this.model_recuperacion.rfc = this.$local_storage.get("rfc_grupo");
      this.model_recuperacion.usuario = this.$local_storage.get("id_usuario","");
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      axios({
          method: "post",
          url: this.$hostname + "vucem/reprogramar_documentos/",
          data: this.model_recuperacion
        })
        .then(response => {
          if (response.data.Mensaje === true) {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "Se han programado los documentos para su recuperación",
              footer: ""
            });
          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: response.data.Mensaje,
              footer: ""
            });
          }
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });


    },
    generaReporteListado(tipoReporte) {
      if (this.$refs.formListado.validate()) {
        if (tipoReporte == "completo") {
          this.generar_reporte_sqs(1);
        } else {
          this.get_data_view(1);
        }
        this.dialog1 = false;
        this.dialog2 = false;
      }
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    clear_values() {
      this.model.pedimento = '';
      this.model.fecha_de = '';
      this.model.fecha_a = '';
      this.model.archivo = '';
      this.listado = "";
    },
    base64ToArrayBuffer: function(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }

      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    simularEstado: function(id_pedimento) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        pedimento: id_pedimento,
      }
      axios({
          method: "post",
          url: this.$hostname + "vucem/agregar_estado_completo/",
          data: datos
        })
        .then(response => {
          if (response.data.Mensaje === true) {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "Se ha simulado el estado de pedimento",
              footer: ""
            });

            this.get_data_view();
          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: response.data.Mensaje,
              footer: ""
            });
          }
        })
        .catch(error => {
          console.log(error);
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
          this.modal_recuperacion = false;
        });
    },
    mostrarErroresRecuperacion: function(row) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id_pedimento: row.id_pedimento,
        tipo: row.tipo_validacion,
        filename: row.archivo
      }
      axios.post(this.$hostname + 'reportes_vucem/recuperaciones_ws_errores/', datos)
        .then((res) => {
          this.errores = res.data;

          for (var k in this.errores) {
            this.errores[k].fecha = this.parseDate(this.errores[k].fecha);
            this.errores[k].error = this.getErrorWS(this.errores[k].error);
          }
          var countErrores = this.errores.length;
          this.intentosRecuperacion = countErrores;
          if (row.estatus == "NO RECUPERABLE" || row.estatus == "RECUPERADO" || row.estatus == "TOKEN INCORRECTO" || row.estatus == "EDOCUMENT PROGRAMADO")
            this.intentosRecuperacion += 1;
          this.mensajeErrores = "Se encontraron " + countErrores + " errores de recuperación para el archivo '" + row.archivo + "' que es un " + row.tipo;
          this.modalErroresRecuperacion = true;

        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener errores de recuperación. Favor de comunicarse con soporte.",
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    downloadReporte: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    cargarErrores: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios.get(this.$hostname + "catalogos/errores_ws/")
        .then(res => {
          this.errores_ws = res.data;
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el catálogo de errores webservice.",
            footer: ""
          });
        }).then(() => {
          this.cargar();
        });
    },
    getErrorWS: function(errorWs) {
      if (errorWs != null && errorWs.toString().trim() != "") {
        var filter = this.errores_ws.filter(function(e) {
          return e.error.toString().trim().toLowerCase() == errorWs.toString().trim().toLowerCase();
        });
        if (filter.length > 0) {
          return filter[0].metadato;
        } else
          return errorWs;
      } else
        return errorWs;

    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargar();
            });
        }
      });
    },
    check_all: function() {
      let arr = this.allChecked ? this.data_view.datos.map(row => row.key) : [];

      if (arr.length == 0) {
        this.to_download = [];
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (this.to_download.includes(arr[i])) {
            continue;
          } else {
            this.to_download.push(arr[i]);
          }
        }
      }
    },
    download_files: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      var data = {
        rfc: this.model.rfc,
        usuario: this.model.usuario,
        pedimento: this.model.pedimento,
        fecha_de: this.model.fecha_de,
        fecha_a: this.model.fecha_a,
        lista: this.model.lista,
        reporte_url: "/reportes_vucem/genera_zip_recuperaciones/",
        nombre_reporte: "Zip Pedimentos WS",
        tipo: this.model.tipo,
        tipo_reporte: this.model.tipo_reporte,
        files: this.to_download
      };
      data["lista"] = this.removerLineasVacias(this.listado);

      if (data.pedimento == '') delete(data['pedimento']);
      if (data.fecha_de == '') delete(data['fecha_de']);
      if (data.fecha_a == '') delete(data['fecha_a']);
      if (data.lista == '' || data.lista == []) {
        delete(data['lista'])
      } else {
        if (data.tipo_reporte == 4) {
          data['lista'] = this.get_array_lista(data['lista'])
        }
      }

      axios({
          method: "post",
          url: this.$hostname + "reportes/save_reporte/",
          data: data
        })
        .then(response => {
          this.to_download = [];
          if (data.tipo_reporte == 4) {
            this.model.lista = '';
            this.lista_filtrada = [];
          }
          this.$swal({
            type: "success",
            title: "Operación Exitosa",
            text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
            footer: ""
          });
        })
        .catch(error => {
          let mensaje;
          var titulo = "¡Operación no Permitida!";
          var tipo = "error";
          if (typeof error.response !== "undefined") {
            mensaje = error.response.data.mensaje;
            if (error.response.status == 406) {
              titulo = "¡Ya existe un reporte en proceso!";
              tipo = "info";
            }
          } else {
            mensaje = "Ocurrió un error al generar el reporte";
          }
          this.$swal({
            type: tipo,
            title: titulo,
            text: mensaje,
            footer: ""
          });
        }).then(() => {
          this.cargar();
          this.$root.$dialogLoader.hide();
        });
    },
    reenviar_no_recuperados_sinrecuperados() {
      let self = this;
      self.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de reenviar todos los archivos no recuperados?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          self.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

          self.datanorecuperados.forEach(function(row) {
            if (row.estatus != 'RECUPERADO') {

              let data = {
                "key": row.id_pedimento,
                "tipo": row.tipo_validacion,
                "filename": row.archivo,
                "estatus": 0, //Se deja en Pendiente para que lo vuelva a encolar
                "size": 0,
                "error": "",
                "usuario": self.$local_storage.get("id_usuario",""),
                "origen": "Recuperaciones AA"
              };

              axios.post("https://apivucem.econnectpro.mx/vucem/actualizar_validacion/", data)
                .then(res => {
                  //No hacemos nada aqui, ya que puede regresar timeout
                })
                .catch(err => {
                  //Puede ser que regrese un timeout, pero igualmente se mostrará mensaje de exito
                }).then(() => {

                  //Solo en caso de que se regenere el 12-PDF de eDocument, también se tiene que mandar el 11-XML del eDocument
                  if (row.tipo_validacion == 12) {
                    data = {
                      "key": row.id_pedimento,
                      "tipo": 11,
                      "filename": row.archivo,
                      "estatus": 0, //Se deja en Pendiente para que lo vuelva a encolar
                      "size": 0,
                      "error": "",
                      "usuario": self.$local_storage.get("id_usuario",""),
                      "origen": "Recuperaciones AA"
                    };
                    axios.post("https://apivucem.econnectpro.mx/vucem/actualizar_validacion/", data)
                      .then(res => {
                        //No hacemos nada aqui, ya que puede regresar timeout
                        self.data_view.datos = [];
                        self.get_data_view(0);
                      })
                      .catch(err => {
                        //Puede ser que regrese un timeout, pero igualmente se mostrará mensaje de exito
                      });
                  } else {
                    self.data_view.datos = [];
                    self.get_data_view(0);
                  }

                });
            }
          });
          //   self.get_data_view(0);
          self.$root.$dialogLoader.hide();
        }

      });

    },
    reenviar_no_recuperados() {
      let self = this;
      self.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de reenviar todos los archivos no recuperados?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          self.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

          //Se cambia a envio masivo, ya que a veces mandan hasta 700 o mil archivos, y antes se hacía uno por uno
          var archivos = []
          self.datanorecuperados.forEach(function(row){
              archivos.push({
                  "key": row.id_pedimento,
                  "tipo": row.tipo_validacion,
                  "filename": row.archivo,
                  "estatus": 0, //Se deja en Pendiente para que lo vuelva a encolar
                  "size": 0,
                  "error": "",
                  "usuario": self.$local_storage.get("id_usuario","")
              });       
              
              //Solo en caso de que se regenere el 12-PDF de eDocument, también se tiene que mandar el 11-XML del eDocument
              if (row.tipo_validacion == 12) {
                  archivos.push({
                      "key": row.id_pedimento,
                      "tipo": 11,
                      "filename": row.archivo,
                      "estatus": 0, //Se deja en Pendiente para que lo vuelva a encolar
                      "size": 0,
                      "error": "",
                      "usuario": self.$local_storage.get("id_usuario",""),
                      "origen": "Recuperaciones AA"
                  });
                      
              } 
          });

          axios.post("https://apivucem.econnectpro.mx/vucem/actualizar_validacion_masiva/", {"archivos":archivos})                
          .then(res => {
              //No hacemos nada aqui
          })
          .catch(err => {
              this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un error al enviar los archivos. Intente nuevamente.",
                  footer: 'Si la cantidad de archivos enviados es muy grande. Espere 5 minutos antes de volver a intentar.',
              });
          }).then(() => {
              self.$root.$dialogLoader.hide();              
              self.get_data_view(0);

          });
          
        }

      });

    },
  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: xx-small !important;
}
</style>
